import React, { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import {
  Box,
  Paper,
  DialogContent,
  DialogActions,
  Button,
  Alert,
} from '@mui/material';
import { useGridApiRef, GRID_CHECKBOX_SELECTION_COL_DEF } from '@mui/x-data-grid';
import { DataGrid } from '../../../components/common/datagrid/ResponsiveDataGrid';
import _ from 'lodash';
import Draggable from 'react-draggable';
import { listProductsPrice } from '../../../modules/productModule/productsPrice';
import BootstrapDialog, {
  BootstrapDialogTitle,
} from '../../../components/common/dialog/BootstrapDialog';
import * as yup from 'yup';
import { ProductListBox } from '../../../components/chancemng/costcalc/ProductListBox';

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-product-dialog"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

const ProdcutPriceModalContainer = ({
  title,
  open,
  handleClose,
  onSelectedProducts,
  selectedPartner,
}) => {
  const dispatch = useDispatch();
  const [pageSize, setPageSize] = React.useState(100);
  const { products, error, loading } = useSelector(
    ({ productModule, loading }) => ({
      products: productModule.productsPrice.products,
      error: productModule.productsPrice.error,
      loading: loading['product/LIST_PRODUCTS_PRICE'],
    }),
  );

  const apiRef = useGridApiRef();

  const columns = useMemo(
    () => [
      {
        field: 'id',
        headerName: 'ID',
        hide: true,
        type: 'string',
        editable: false,
      },
      {
        field: 'priceUuid',
        headerName: 'priceUuid',
        hide: true,
        type: 'string',
        editable: false,
      },
      {
        field: 'productUuid',
        headerName: '제품코드',
        hide: true,
        type: 'string',
        editable: false,
      },
      {
        field: 'partnerNm',
        headerName: '제조사',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
      },
      {
        // 2026-10-23 (250423 피드백 "추가" 항목): 제조사만 보이고 매입처가 안 보여
        // 선택이 헷갈린다는 요청 — 주석 해제. 데이터(pricePartnerNm)는 이미
        // modules/productModule/productsPrice.js 리듀서가 매핑해두고 있었다.
        field: 'pricePartnerNm',
        headerName: '매입처',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
      },
      {
        field: 'productNm',
        headerName: '제품명',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
      },
      {
        field: 'productDesc',
        headerName: '사양',
        hide: true,
      },
      {
        field: 'productUnit',
        headerName: '단위',
        hide: true,
      },
      {
        field: 'category',
        headerName: '아이템',
        hide: true,
      },
      {
        field: 'modelNm',
        headerName: '모델명',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
      },

      {
        field: 'priceUuid',
        headerName: '가격ID',
        minWidth: 200,
        flex: 1,
        hide: true,
      },
      // "가격타입" 컬럼 제거(2026-10-27, 제품 가격타입 제거) - 이 모달은 항상 매입가 기준.
      {
        field: 'priceVal',
        headerName: '매입가',
        minWidth: 150,
        flex: 0.8,
        type: 'number',
        editable: false,
        valueFormatter: (value) => {
          const valueFormatted = Number(value).toLocaleString('ko-KR');
          return `₩ ${valueFormatted}`;
        },
      },
      // 매출가: 제품마스터에 등록된 매출 단가(제품당 1건)를 기본값으로 보여준다.
      // CostCalcForm에서 거래처별로 직접 수정 가능(2026-10-27, 제품 가격타입 제거 - owner
      // 결정: 매입처/매입가/매출가를 코스트라인에 그대로 반영).
      {
        field: 'salesVal',
        headerName: '매출가',
        minWidth: 150,
        flex: 0.8,
        type: 'number',
        editable: false,
        valueFormatter: (value) => {
          if (value === null || value === undefined || value === '') return '';
          const valueFormatted = Number(value).toLocaleString('ko-KR');
          return `₩ ${valueFormatted}`;
        },
      },
    ],
    [],
  );

  const onSaveCalcPrice = () => {
    //const rowIds = Array.from(apiRef.current.getSelectedRows().keys());
    const rowValues = Array.from(apiRef.current.getSelectedRows().values());
    // console.log(rowValues, 'rows');

    const data = [];
    _.map(rowValues, (row) => {
      let productPrice = {
        ...row,
        // 2026-10-23: 원가산출 코스트라인의 "매입처" 필드(sellPartnerNm)는 지금까지
        // 제조사(row.partnerNm)를 그대로 복사해 매입처 선택이 반영되지 않았다.
        // 매입처(row.pricePartnerNm)가 있으면 그걸 우선 사용하고, 없으면(레거시 데이터)
        // 기존처럼 제조사로 대체한다.
        sellPartnerNm: row.pricePartnerNm || row.partnerNm,
        sellPartnerUuid: row.pricePartnerUuid || row.partnerUuid,
        // partnerUuid: row.partnerUuid,
        // priceUuid: row.priceUuid,
        // productUuid: row.productUuid,
        expCnt: 1,
        // 매출단가(unitVal): 제품마스터의 매출가를 기본값으로 채우고, 거래처별로
        // CostCalcForm에서 직접 수정할 수 있게 둔다(2026-10-27, 제품 가격타입 제거 -
        // 매입 / 매출 2종 고정 모델로 전환하면서 owner 결정으로 매출가 prefill 복원).
        unitVal: row.salesVal || '',
        priceVal: row.priceVal, //매입단가
        buyVal: row.priceVal, //매입금액
        salePct: 0,
        productDesc: row.productDesc,
        productUnit: row.productUnit,
        itemCd: row.category,
      };
      data.push(productPrice);
    });

    onSelectedProducts(data);
    onCloseHandler();
  };

  const [searchKeyword, setSearchKeyword] = useState('productNm');
  const [searchWords, setSearchWords] = useState('');

  const initialValues = {
    searchKeyword: searchKeyword,
    searchWords: searchWords,
  };

  const validationSchema = yup.object({
    searchKeyword: yup.string('').nullable(),
    searchWords: yup.string('').trim().nullable(),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true);
      setSearchKeyword(values.searchKeyword);
      setSearchWords(values.searchWords);

      setSubmitting(false);
    },
  });

  const onSearchList = () => {
    let searchData = {
      searchPartnerUuid: selectedPartner,
      [searchKeyword]: searchWords,
    };

    dispatch(listProductsPrice(searchData));
  };

  useEffect(() => {
    onSearchList();
  }, [selectedPartner, searchKeyword, searchWords]);

  const onCloseHandler = () => {
    setSearchKeyword('productNm');
    setSearchWords('');
    handleClose();
  };

  return (
    <BootstrapDialog
      open={open}
      onClose={onCloseHandler}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-product-dialog"
      fullWidth={true}
      maxWidth="lg"
    >
      <BootstrapDialogTitle
        style={{ cursor: 'move' }}
        id="draggable-product-dialog"
        onClose={onCloseHandler}
      >
        원가 산출 - 제품 선택
      </BootstrapDialogTitle>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <DialogContent>
          {!selectedPartner && (
            <Alert severity="warning" sx={{ mb: 2 }}>
              이 기회에 "매출처"가 아직 선택되지 않아 제품이 검색되지 않습니다.
              기회분석 탭의 "거래처 정보"에서 매출처를 선택하고 저장한 뒤 다시
              시도하세요.
            </Alert>
          )}
          <Box>
            <ProductListBox formik={formik} />
          </Box>
          <div style={{ display: 'flex', height: 'calc(100vh - 300px)' }}>
            <div style={{ flexGrow: 1 }}>
              <DataGrid
                apiRef={apiRef}
                rows={products ? products : []}
                columns={columns}
                loading={loading}
                initialState={{
                  pinnedColumns: {
                    left: [GRID_CHECKBOX_SELECTION_COL_DEF.field],
                    right: ['actions'],
                  },
                }}
                pageSize={pageSize}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                rowsPerPageOptions={[5, 10, 20, 50, 100]}
                pagination
                checkboxSelection
                disableSelectionOnClick
                columnVisibilityModel={{
                  id: false,
                  priceUuid: false,
                  productUuid: false,
                }}
                        
              />
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button fullWidth variant="contained" onClick={onSaveCalcPrice}>
            제품 추가(다중선택 가능)
          </Button>
        </DialogActions>
      </Box>
    </BootstrapDialog>
  );
};

export default ProdcutPriceModalContainer;
